module.exports = __webpack_public_path__ + "img/file-regiter.b49a500e.svg";